/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  TextField,
  IconButton,
  MenuItem,
  Menu,
  Modal,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import feedbackService from "services/feedback-service";

export default function UnitSelect({
  label,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  levelId,
  designationId,
  placeholder,
  disabled,
  hasData,
  options,
  sx,
}) {
  const [offices, setOffices] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOffices, setSelectedOffice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState(false);

  // console.log(designationId);

  // Detect mobile devices
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    console.log({ levelId, designationId });

    setLoading(true);
    feedbackService
      .getFilteredUnits({ levelId, designationId })
      .then((response) => {
        console.log(response);

        hasData(response);
        setOffices(response);
        setSelectedOffice(
          response.find((office) => office.id === value) || null
        );
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [levelId, designationId]);

  useEffect(() => {
    setSelectedOffice(offices?.find((office) => office.id === value) || null);
  }, [offices, value]);

  const handleClick = (event) => {
    if (isMobile) {
      setOpenModal(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    setOpenModal(false);
    if (newValue) {
      onChange?.(name, newValue.id || "");
      setSelectedOffice(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, "");
    setSelectedOffice(null);
  };

  useEffect(() => {
    if (options) {
      setOffices(options);
    }
  }, [options]);

  return (
    <Box>
      <TextField
        label={error ? `${label} - ${error}` : label}
        placeholder={error ? `${placeholder} - ${error}` : placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={selectedOffices && value ? selectedOffices.title : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedOffices && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disabled && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />

      {/* Normal Menu for Desktop */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
        slotProps={{
          paper: {
            sx: {
              maxHeight: "30vh", // Limits height to 60% of viewport height
              overflowY: "auto", // Enables scrolling
              maxWidth: "100%", // Adjust width if needed
              "@media (min-height: 1080px)": {
                maxHeight: "40vh", // Increases max height for taller screens
                width: "60%",
              },
            },
          },
        }}
      >
        <Typography
          sx={{ px: 2, py: 1, fontWeight: "bold", fontSize: "0.9rem" }}
        >
          {designationId === 2 ? "Select School" : "Select a Unit"}
        </Typography>
        <Divider />
        {offices.map((office, index) => (
          <div key={office.id}>
            <MenuItem
              sx={{
                width: "100%",
                fontSize: { xs: "0.8rem", xl: "1rem" }, // Reduced font size
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              }}
              onClick={() => handleClose(office)}
            >
              {office.title}
            </MenuItem>
            {index !== offices.length - 1 && <Divider />}{" "}
            {/* Divider between items */}
          </div>
        ))}
      </Menu>

      {/* Scrollable Modal for Mobile */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxHeight: "50vh", // Set max height to make it scrollable
            overflowY: "auto", // Enable vertical scrolling
            bgcolor: "background.paper",
            boxShadow: 24,
            // borderRadius: "10px",
            p: 3,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: "bold", fontSize: "1rem" }}>
              Select a Unit
            </Typography>
            <IconButton onClick={() => setOpenModal(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 1 }} />

          <List>
            {offices.map((office, index) => (
              <div key={office.id}>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => handleClose(office)}>
                    <ListItemText
                      primary={office.title}
                      sx={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
                {index !== offices.length - 1 && (
                  <Divider sx={{ width: "100%", color: "black" }} />
                )}{" "}
                {/* Divider between items */}
              </div>
            ))}
          </List>
        </Box>
      </Modal>
    </Box>
  );
}
